/* eslint-disable react/no-direct-mutation-state */
import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { formConstants } from '../../utils/constants/form-constants';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import FormBuilder from '../helpers/form-builder';
import FormMessage from '../../common/utility/FormMessage';
import FormSpinner from '../../common/utility/FormSpinner';
import * as registerFormActions from '../../../store/actions/register-form-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import initialState from '../helpers/form-helpers/initial-state';
import SSOFormHeader from '../../common/utility/SSOFormHeader';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import { isEmpty } from '../../utils/obj-utils';
import RegisterFormBanner from '../one-club-register/RegisterFormBanner';
import { getFormDataUrl } from '../../../store/api/api-utils';
import { validateEmail } from '../../../validators/text-validators';
import HeaderLinkDisplay from '../helpers/header-link-display';
import GTMUserActions from '../../common/utility/GTMUserActions';
import { getFormContainerWideLeftClassList, getModalContentClassListForSSOForm, toggleBemClassesForSSOFormModal } from '../helpers/form-helpers/form-modal-helpers';
import { ssoFormTypes } from '../../utils/form-types';
import { hasValue } from '../../../../../general/js/general-helpers';

class BallotRegisterForm extends Component {
    constructor(props) {
        super(props);
        const { registerFormData } = this.props;
        const { ssoDomain } = registerFormData;

        this.state = {
            ...initialState.ballotRegisterFormState,
            registerFormData,
            ssoDomain,
            isModalStylingUpdated: false
        };

        this.formMessageRef = React.createRef();
        this.formReference = React.createRef();

        this.displayBallotRegisterForm = this.displayBallotRegisterForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.loadFormData = this.loadFormData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.handleUserRegisterSuccess = this.handleUserRegisterSuccess.bind(this);
        this.submitRegisterData = this.submitRegisterData.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.getHeaderLink = this.getHeaderLink.bind(this);

        this.formReferences = formScrollHelpers.getFormReferences(registerFormData);

        this.loadFormData();
    }

    loadFormData() {
        const { registerFormData, ssoFormType, actions } = this.props;

        if (!isEmpty(registerFormData)) { return; }

        const formDataUrl = getFormDataUrl(ssoFormType);

        actions.loadSSORegisterFormData(formDataUrl);
    }

    componentDidMount() {
        this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, this.props, ssoFormTypes.BallotLiteRegister);
    }

    componentWillReceiveProps(nextProps) {
        const {
            isRegisterSuccessful,
            loading,
            registerFormData,
            isUserEmailAlreadyUsed,
            onSignIn
        } = nextProps;

        const previousRegisterFormData = this.props.registerFormData;

        if (hasValue(registerFormData) && !this.state.isModalStylingUpdated) {
            this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, nextProps, ssoFormTypes.BallotLiteRegister);
        }

        if (!loading &&
            isRegisterSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false), this.handleUserRegisterSuccess);
            return;
        }

        if (!loading && isUserEmailAlreadyUsed) {
            this.setState(
                (state) => {
                    const updatedErrors = state.errors;

                    const { emailValidation } = registerFormData;

                    updatedErrors.emailAddress = { isValid: false, errorMessage: this.getHeaderLink(emailValidation.emailHeaderLink, onSignIn, emailValidation.signInMessage) };

                    return {
                        ...state,
                        errors: updatedErrors
                    };
                }
            );
            return;
        }

        if (!loading &&
            !isRegisterSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false),
                () => {
                    formScrollHelpers.scrollToField(this.formMessageRef);
                });
        }

        if (isEmpty(previousRegisterFormData) && !isEmpty(registerFormData)) {
            this.setState(
                (prevState) => ({
                    ...prevState,
                    registerFormData
                })
            );

            this.formReferences = formScrollHelpers.getFormReferences(registerFormData);
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.defaultRegisterFormState);
        actions.resetRegisterFormState();
    }

    handleUserRegisterSuccess() {
        const { onUserRegisterSuccess } = this.props;

        const {
            formType,
            actionSuccessText,
            requestEmailVerificationCallbackUrl,
            requestEmailVerificationActionSuccessText,
            formBanner
        } = this.props.registerFormData;

        onUserRegisterSuccess(this.state[formConstants.emailAddress],
            {
                isBallotRegister: true,
                registerFormType: formType,
                successText: actionSuccessText,
                emailVerificationCallbackUrl: requestEmailVerificationCallbackUrl,
                emailVerificationActionSuccessText: requestEmailVerificationActionSuccessText,
                displayBanner: true,
                bannerBackgroundImageSrc: formBanner.bannerBackgroundImageSrc
            });
    }

    async handleSubmit(event) {
        event.preventDefault();
        const { registerFormData } = this.props;
        const { reCaptcha } = this.state;

        if (reCaptcha) {
            registerFormData.reCaptchaToken = reCaptcha;
        }

        this.setState(formStateHelpers.handleFormValidation(registerFormData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }
        const captchaRef = this.formReferences[formConstants.reCaptcha];

        if (captchaRef) {
            captchaRef.current.props.grecaptcha.reset();
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitRegisterData);
    }

    handleFieldChange(event) {
        this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target));
    }

    handleOnBlur(event) {
        const { actions, registerFormData } = this.props;
        const { previousCheckedEmail } = this.state;

        const { emailValidation } = registerFormData;

        const emailValue = event.target.value;

        if (event.target.name === formConstants.emailAddress && !isEmpty(emailValue) && previousCheckedEmail !== emailValue) {
            const isEmailValid = validateEmail(emailValue);

            if (isEmailValid.isValid) {
                this.setState((state) => ({
                    ...state,
                    previousCheckedEmail: emailValue,
                    emailCheckInProgress: true
                }));

                actions.verifyIfEmailAddressExists(emailValue, emailValidation.emailValidationEndpoint);
            }
        }
    }

    submitRegisterData() {
        const { actions, registerFormData } = this.props;
        const { callBackUrlPost } = registerFormData;
        const actionSuccessText = registerFormData.actionSuccessText || formMessageConstants.registrationSuccessText;

        registerFormData.zoneInfo = formConstants.isBallotRegister;

        actions.registerNewUser(this.state, actionSuccessText, callBackUrlPost);
        this.setState({ reCaptcha: '' });

        GTMUserActions.trackJoinTheOneClubAction();
    }

    getHeaderLink(headerMessage, headerLink, headerLinkText) {
        return <HeaderLinkDisplay headerMessage={headerMessage}
            headerLink={headerLink}
            headerLinkText={headerLinkText}
        ></HeaderLinkDisplay >;
    }

    displayForm() {
        const {
            onSignIn,
            isRegisterSuccessful,
            userRegistrationMessages,
            registerFormData
        } = this.props;

        const { formHeader } = registerFormData;

        if (isEmpty(registerFormData)) { return null; }

        return (<Fragment>
            <SSOFormHeader
                headerTitle={formHeader.headerTitle}
                headerMessage={formHeader.headerMessage}
                headerLinkText={formHeader.headerLinkText}
                linkCallBackUrl={onSignIn}
                displayForgotPasswordLink={false}></SSOFormHeader>
            <form onSubmit={this.handleSubmit}>
                <FormMessage formRef={this.formMessageRef}
                    isSuccessMessage={isRegisterSuccessful}
                    messages={userRegistrationMessages}></FormMessage>
                {this.displayBallotRegisterForm()}
                <SSOFormFooter
                    onSubmit={this.handleSubmit}
                    footerButtonText={formMessageConstants.submitDefaultFormButtonText}></SSOFormFooter>
            </form>
        </Fragment>);
    }

    displayBallotRegisterForm() {
        const { registerFormData } = this.props;
        const { mobilePhone } = registerFormData;

        return FormBuilder({
            formData: registerFormData,
            formReferences: this.formReferences,
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => {
                this.handleFieldChange(event);
            },
            handleConfirmPasswordChange: (event) => { this.setState(formStateHelpers.handleConfirmPasswordFieldChange(event.target)); },
            handleMobilePhoneChange: (event) => { this.setState(formStateHelpers.handleMobilePhoneChange(event, mobilePhone.isOptional)); },
            handleCaptchaChange: (token) => { this.setState(formStateHelpers.handleCaptchaChange(token)); },
            handleMastercardNumberChange: (event) => {
                this.setState(formStateHelpers.handleMastercardNumberChange(event.target,
                    registerFormData.mastercardRegex, registerFormData.mastercardValidationError));
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            },
            handleOnBlur: this.handleOnBlur
        });
    }

    render() {
        const { isSaving } = this.state;
        const { loading, registerFormData } = this.props;
        const { formBanner, desktopImageSrc, mobileImageSrc } = registerFormData;

        const emptyForm = isEmpty(registerFormData);

        return (
            <div ref={this.formReference} className={getModalContentClassListForSSOForm(this.props)}>
                <div className={getFormContainerWideLeftClassList(this.props)}>
                    {
                        hasValue(mobileImageSrc) &&
                        <div>
                            <img src={mobileImageSrc} className='form-container__banner--mobile' data-sizes="auto" />
                        </div>
                    }
                    {
                        emptyForm ? null : <RegisterFormBanner
                            formBanner={formBanner}
                        ></RegisterFormBanner>
                    }
                    <div className='form-container__form'>
                        {(isSaving || loading) ? <FormSpinner>/</FormSpinner> : null}
                        {this.displayForm()}
                    </div>
                </div>
                {
                    hasValue(desktopImageSrc) &&
                    <div className='form-container__wide--right'>
                        <img src={desktopImageSrc} className='form-container__banner--desktop' data-sizes="auto" />
                    </div>
                }
            </div>
        );
    }
}

BallotRegisterForm.propTypes = {
    onSignIn: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    onUserRegisterSuccess: PropTypes.func.isRequired,
    registerFormData: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isRegisterSuccessful: state.registerForm.isRegisterSuccessful,
        userRegistrationMessages: state.registerForm.userRegistrationMessages,
        isUserEmailAlreadyUsed: state.registerForm.isUserEmailAlreadyUsed,
        registerFormData: !hasValue(ownProps.registerFormData) ? state.registerForm.registerFormData : ownProps.registerFormData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            registerNewUser: bindActionCreators(registerFormActions.registerNewUser, dispatch),
            resetRegisterFormState: bindActionCreators(registerFormActions.resetRegisterFormState, dispatch),
            loadSSORegisterFormData: bindActionCreators(registerFormActions.loadSSOOneClubRegisterFormData, dispatch),
            verifyIfEmailAddressExists: bindActionCreators(registerFormActions.verifyIfEmailAddressExists, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BallotRegisterForm);
